"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'settings.general.title': 'Ustawienia Ogólne',
    'settings.general.description': 'Skonfiguruj ustawienia aplikacji i integracje',
    'settings.general.tabs.googleDrive': 'Google Drive',
    'settings.general.tabs.general': 'Ogólne',
    'settings.general.tabs.apiKeys': 'Klucze API',
    'settings.general.tabs.rag': 'Ustawienia RAG',
    'settings.general.tabs.credit': 'Ustawienia Kredytów',
    'settings.general.tabs.socialMedia': 'Social Media',
    'settings.general.generalSettings.comingSoon': 'Ustawienia ogólne będą wkrótce dostępne.',
    'settings.general.apiKeys.comingSoon': 'Zarządzanie kluczami API będzie wkrótce dostępne.',
    'settings.general.chatLearning.title': 'Podsumowanie Uczenia Czatu',
    'settings.general.chatLearning.description': 'Zarządzaj swoim spersonalizowanym podsumowaniem uczenia AI. Te informacje pomagają AI dostarczać lepsze, bardziej dostosowane odpowiedzi.',
    'settings.general.chatLearning.summaryLabel': 'Podsumowanie Uczenia',
    'settings.general.chatLearning.summaryPlaceholder': 'Wprowadź lub edytuj informacje o swoich preferencjach, kontekście i ważnych szczegółach, które powinny pomóc AI lepiej Ci asystować...',
    'settings.general.chatLearning.summaryHelp': 'To podsumowanie jest automatycznie aktualizowane na podstawie Twoich rozmów. Możesz je ręcznie edytować, aby uwzględnić konkretne preferencje lub kontekst.',
    'settings.general.save': 'Zapisz Ustawienia',
    'settings.general.reload': 'Odśwież',
    'settings.general.savedSuccessfully': 'Ustawienia ogólne zapisane pomyślnie',
    'settings.general.failedToSave': 'Błąd zapisywania ustawień ogólnych',
    'settings.general.failedToLoad': 'Błąd ładowania ustawień ogólnych',
};
